export default __webpack_public_path__ + "static/media/control.02849d7f.png";